import getAboutData from "../about-data";


export default function About() {
    return (
        getAboutData()
    )
}